import { render, staticRenderFns } from "./VxSidebar.vue?vue&type=template&id=424687d8&lang=pug"
import script from "./VxSidebar.vue?vue&type=script&lang=js"
export * from "./VxSidebar.vue?vue&type=script&lang=js"
import style0 from "./VxSidebar.vue?vue&type=style&index=0&id=424687d8&prod&lang=scss"
import style1 from "./VxSidebar.vue?vue&type=style&index=1&id=424687d8&prod&lang=css"
import style2 from "./VxSidebar.vue?vue&type=style&index=2&id=424687d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports